import { Group, Paper, Text, ThemeIcon, Title } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { ReactNode } from "react";

export const StatCard = ({
  label,
  icon,
  value,
  hint,
  isWarning = false,
}: {
  label: string;
  icon: ReactNode;
  value: number;
  hint: string;
  isWarning?: boolean;
}) => (
  <Paper withBorder radius="md" bg="cardBackground" py="s4" px="s5">
    <Group justify="space-between" mb="s3">
      <Text fz={12.5} fw={500} c="ink.4">
        {label}
      </Text>
      <ThemeIcon size={28} radius="sm" bg="ink.0" c="ink.4">
        {icon}
      </ThemeIcon>
    </Group>
    <Title variant="display" size="md">
      {value}
    </Title>
    <Group gap={4} mt={2}>
      {isWarning && (
        <IconAlertCircle size={12} color="var(--mantine-color-amber-6)" />
      )}
      <Text variant="caption" c={isWarning ? "amber.6" : undefined}>
        {hint}
      </Text>
    </Group>
  </Paper>
);
